import { useEffect, useRef, useState } from 'react';

export default function useHighlightOnAdd(shouldHighlight) {
  const ref = useRef(null);
  const [isHighlighted, setIsHighlighted] = useState(false);

  useEffect(() => {
    if (!shouldHighlight) return undefined;

    ref.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setIsHighlighted(true);

    // Duplo requestAnimationFrame garante que o navegador pinte o estado "true"
    // (fundo em destaque) antes de voltar para "false" — sem isso, o React
    // poderia agrupar as duas mudanças de estado e nunca chegar a desenhar o
    // destaque, pulando direto para o fundo normal.
    let raf2;
    const raf1 = requestAnimationFrame(() => {
      raf2 = requestAnimationFrame(() => setIsHighlighted(false));
    });

    return () => {
      cancelAnimationFrame(raf1);
      if (raf2) cancelAnimationFrame(raf2);
    };
  }, [shouldHighlight]);

  return { ref, isHighlighted };
}
